document.addEventListener(
  'click',
  function (e) {
    var chip = e.target.closest('.colourway-flyout__chip');
    if (!chip) return;

    var filterRow = chip.closest('[data-colourway-filter]');
    var grid = filterRow && filterRow.parentElement.querySelector('[data-colourway-grid]');
    if (!grid) return;

    filterRow.querySelectorAll('.colourway-flyout__chip').forEach(function (btn) {
      btn.classList.toggle('is-active', btn === chip);
    });

    var filter = chip.getAttribute('data-filter');
    grid.querySelectorAll('[data-colourway-card]').forEach(function (card) {
      var show = filter === 'all' || card.getAttribute('data-tech') === filter;
      card.style.display = show ? '' : 'none';
    });
  },
  true // capture phase - the flyout panel stops click bubbling to implement click-outside-to-close
);
